import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#114A4E",
      d: "M17 8.054 6.08 18.973a.72.72 0 0 1-.521.213.7.7 0 0 1-.532-.213.72.72 0 0 1-.217-.527q0-.31.217-.527L15.947 7H9.75a.73.73 0 0 1-.534-.216A.73.73 0 0 1 9 6.25q0-.32.216-.535A.73.73 0 0 1 9.75 5.5h7.846q.383 0 .644.26.26.26.26.644v7.846q0 .319-.216.534a.73.73 0 0 1-.534.216.73.73 0 0 1-.535-.216.73.73 0 0 1-.215-.534z"
    }, null, -1)
  ])))
}
export default { render: render }